import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../components/base.component';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ConfirmationDialogModel } from '../../model/confirmation-dialog.model';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent extends BaseComponent implements OnInit {

  public model: ConfirmationDialogModel;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogModel) { 
    super();
  }

  ngOnInit(): void {
    this.model = this.data;
  }

  public onClose(confirm: boolean){
    if(confirm){
      this.closed.emit(confirm);
    }else{
      this.dialogRef.close();
    }
  }

}
